import { createContext, useState, useEffect } from "react";
import { useContext } from "react";
import { CartContext } from "./CartContext"; // adjust path if needed

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const { clearCart } = useContext(CartContext); // ✅ safe because CartProvider wraps AuthProvider

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");
    const astrologerId = localStorage.getItem("astrologerId");

    setIsAuthenticated(!!token || !!userId || !!astrologerId);
    setLoading(false);
  }, []);

  const login = ({ token, userId = null, astrologerId = null }) => {

    localStorage.removeItem("authToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("astrologerId");
    setIsAuthenticated(false);

    if (token) localStorage.setItem("authToken", token);
    if (userId) localStorage.setItem("userId", userId);
    if (astrologerId) localStorage.setItem("astrologerId", astrologerId);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("astrologerId");
    clearCart(); // ✅ clear cart state and localStorage
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};